export default __webpack_public_path__ + "static/Skoda_Fuerth_2019-05-19_0592_B-e5ff2b7440812a02fab0c15dc8b2a401.jpg";